import { Inject, Injectable } from '@angular/core';
import {
  LogMessage,
  LogMessageKeys,
  LogMessageSourceTypes,
  LogMessageTypes,
  SupportedCollections,
} from '@ag-common-lib/public-api';
import { FirebaseApp } from 'firebase/app';
import { FIREBASE_APP } from '../injections/firebase-app';
import { DataService } from './data.service';
import { CloudFunctionsService } from './cloud-functions.service';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';

@Injectable({
  providedIn: 'root',
})
export class LoggerService extends DataService<LogMessage> {
  public includeLogs: boolean = false;

  constructor(
    @Inject(FIREBASE_APP) fireBaseApp: FirebaseApp,
    private cloudFunctionsService: CloudFunctionsService,
    // private authService: AuthService,
  ) {
    super(fireBaseApp, null, null);
    this.collection = 'log-messages';
  }

  public async createLog(
    type: LogMessageTypes,
    sourceType: LogMessageSourceTypes,
    source: string,
    message: string,
    payload?: any,
  ): Promise<string> {
    try {
      const currentUser = this.fsDao.auth.currentUser;
      const idTokenResult = !!currentUser ? await currentUser?.getIdTokenResult() : null;
      const loggedInAgentDbId = idTokenResult?.claims?.agentDbId;
      const logMessage: LogMessage = Object.assign({}, new LogMessage(type, sourceType, source, message, payload), {
        [BaseModelKeys.createdDate]: new Date(),
        [BaseModelKeys.createdBy]: currentUser?.uid ?? null,
        [BaseModelKeys.createdByEmail]: currentUser?.email ?? null,
        [BaseModelKeys.createdByAgentDbId]: loggedInAgentDbId ?? null,
      });

      await Promise.all([
        this.cloudFunctionsService.shipDocumentToElastic({
          indexName: SupportedCollections.logMessages,
          documentData: logMessage,
        }),
        super.create(logMessage),
      ]);

      return logMessage?.[LogMessageKeys.errorCode];
    } catch (error) {
      return '';
    }
  }
}
